import Vue from "vue";
export default Vue.extend({
    props: ["value"],
    data() {
        return {
            allocationFidelity: [
                { id: "Weekly", name: "week", icon: "mdi-calendar-weekend-outline" },
                { id: "Monthly", name: "month", icon: "mdi-calendar-month-outline" },
                { id: "Yearly", name: "year", icon: "mdi-calendar-check-outline" },
            ],
        };
    },
    methods: {
        onAllicationidelityChange(fidelity) {
            this.$emit("change", fidelity);
        },
    },
});
